'use strict';

export const Z_INDEX_FIXED_LEVEL = 100;

export const COLOURS = {
  disciplines: {
    swim:  '#0087D5',
    bike:  '#DF0000',
    run:   '#EE6100',
    gym:   '#4DDC00',
    total: '#000000',
    other: '#9328E0',
  },
  intensity: {
    0: '#f1f1f1',
    1: '#53bdf8',
    2: '#bbeb8f',
    3: '#ffe57d',
    4: '#ffac52',
    5: '#ff6e6e',
    goal: 'rgba(192, 192, 192, 0.2)'
  }
}
